

import { Direction } from '@angular/cdk/bidi';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { MessageConfig, MwcConfigService } from 'mwc/core/config';
import { toCssPixel } from 'mwc/core/util';

import { MwcMNContainerComponent } from './base';

const NZ_CONFIG_COMPONENT_NAME = 'message';

const NZ_MESSAGE_DEFAULT_CONFIG: Required<MessageConfig> = {
  mwcAnimate: true,
  mwcDuration: 3000,
  mwcMaxStack: 7,
  mwcPauseOnHover: true,
  mwcTop: 24,
  mwcDirection: 'ltr'
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  selector: 'mwc-message-container',
  exportAs: 'mwcMessageContainer',
  preserveWhitespaces: false,
  template: `
    <div class="mwc-message" [class.mwc-message-rtl]="dir === 'rtl'" [style.top]="top">
      <mwc-message
        *ngFor="let instance of instances"
        [instance]="instance"
        (destroyed)="remove($event.id, $event.userAction)"
      ></mwc-message>
    </div>
  `
})
export class MwcMessageContainerComponent extends MwcMNContainerComponent {
  dir: Direction = 'ltr';
  top?: string | null;

  constructor(cdr: ChangeDetectorRef, mwcConfigService: MwcConfigService) {
    super(cdr, mwcConfigService);
    const config = this.mwcConfigService.getConfigForComponent(NZ_CONFIG_COMPONENT_NAME);
    this.dir = config?.mwcDirection || 'ltr';
  }

  protected subscribeConfigChange(): void {
    this.mwcConfigService
      .getConfigChangeEventForComponent(NZ_CONFIG_COMPONENT_NAME)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateConfig();
        const config = this.mwcConfigService.getConfigForComponent(NZ_CONFIG_COMPONENT_NAME);
        if (config) {
          const { mwcDirection } = config;
          this.dir = mwcDirection || this.dir;
        }
      });
  }

  protected updateConfig(): void {
    this.config = {
      ...NZ_MESSAGE_DEFAULT_CONFIG,
      ...this.config,
      ...this.mwcConfigService.getConfigForComponent(NZ_CONFIG_COMPONENT_NAME)
    };

    this.top = toCssPixel(this.config.mwcTop);
    this.cdr.markForCheck();
  }
}
